import React from 'react';
import { usePageTitle } from '../hooks/usePageTitle';

export default function PrivacyPolicy() {
  usePageTitle({
    title: 'Privacy Policy',
    description: 'Learn how we protect your privacy and handle your data when using our AI avatar generation service.'
  });
  return (
    <>
      <div className="py-4 py-lg-4 py-md-5"></div>
      <div className="container">
        <div className="row justify-content-start">
          <div className="col-12 col-md-10 offset-md-1">
            <h1 className="display-1 text-dark">
              Privacy Policy
            </h1>
          </div>
        </div>
      </div>

      <div className="container">
        <div className="row justify-content-start">
          <div className="col-12 col-md-8 offset-md-1 col-lg-7 offset-lg-1">
            <div className="py-4">
              <h2 className="fs-3 fw-light mb-4">
                Last updated: {new Date().toLocaleDateString()}
              </h2>
              
              <div className="mb-5">
                <h3 className="h4 mb-3">1. Information We Collect</h3>
                <p className="c-c3">
                  We collect information you provide directly to us, such as when you create an account, 
                  contact us, or use our services. This may include your name, email address, company 
                  information, and any other information you choose to provide.
                </p>
              </div>

              <div className="mb-5">
                <h3 className="h4 mb-3">2. How We Use Your Information</h3>
                <p className="c-c3">
                  We use the information we collect to provide, maintain, and improve our services, 
                  communicate with you, and develop new features. We may also use your information 
                  to send you updates about our services.
                </p>
              </div>

              <div className="mb-5">
                <h3 className="h4 mb-3">3. Information Sharing</h3>
                <p className="c-c3">
                  We do not sell, trade, or otherwise transfer your personal information to third parties 
                  without your consent, except as described in this policy or as required by law.
                </p>
              </div>

              <div className="mb-5">
                <h3 className="h4 mb-3">4. Data Security</h3>
                <p className="c-c3">
                  We implement appropriate security measures to protect your personal information 
                  against unauthorized access, alteration, disclosure, or destruction.
                </p>
              </div>

              <div className="mb-5">
                <h3 className="h4 mb-3">5. Your Rights</h3>
                <p className="c-c3">
                  You have the right to access, update, or delete your personal information. 
                  You may also opt out of certain communications from us.
                </p>
              </div>

              <div className="mb-5">
                <h3 className="h4 mb-3">6. Contact Us</h3>
                <p className="c-c3">
                  If you have any questions about this Privacy Policy, please contact us at{' '}
                  <a href="mailto:hello@itora.io" className="c-c00">hello@itora.io</a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
} 